
import store from '../../../store';
import CookieHelper from "../../../common/helpers/CookieHelper";
import { useRoute } from 'vue-router';
import Confirmation from '../components/steps/Confirmation.vue'
import PersonalInfo from "../components/steps/PersonnalInfo.vue";


import {GET_CART_KITS, GET_LATEST_ORDER,CREATE_ORDER,SET_ORDER_EDIT_MODE,GET_PRICE_BREAKDOWN,EDIT_ALL_ORDER_DETAILS,UPDATE_ORDER_Id,ADD_KITS_TO_CART,GET_DASHBOARD_ORDER_BY_ID,UPDATE_STEPPER  } from "../store/actions"


export default function (){
    const route = useRoute();
    const getOrCreateOrder = async () =>
    {
        
        if(!store.getters.isAuthenticated){
            store.dispatch('TOGGLE_AUTH_POPUP', true);
          }
          else{

            if (route.params.id)
            {
              store.commit('update_is_dashboard_order',true)
              let getOrderById= await store.dispatch(GET_DASHBOARD_ORDER_BY_ID,route.params.id)
              await store.commit(SET_ORDER_EDIT_MODE,true)
              await store.dispatch(EDIT_ALL_ORDER_DETAILS);
            }
            else
            {
              store.commit('update_is_dashboard_order',false)
              await store.commit(UPDATE_ORDER_Id, undefined);
              await store.dispatch(GET_CART_KITS, store.getters.cartItems);
              let latestOrder= await store.dispatch(GET_LATEST_ORDER)
              if(latestOrder==null)
              {
                await store.dispatch(CREATE_ORDER).then((res) => {});
              }
              else{
                await store.commit(SET_ORDER_EDIT_MODE,true)
                await store.dispatch(EDIT_ALL_ORDER_DETAILS).then((res) => {});
              }
            }  
        }

        InitializeStepper()
    }

    function loadCartItemsFromCookie()
    {
        var items = CookieHelper.getCookie("cartItems");
        if (items != null) {
            var j = JSON.parse(items);
            store.dispatch(ADD_KITS_TO_CART, j);
        }
    }

    function InitializeStepper()
    {
      if (store.getters.status_id == 2)
      {
        store.dispatch(UPDATE_STEPPER, ["confirmationDisplayActive"]);
        store.commit("checkoutActiveComponent", Confirmation);
        store.commit("setStepperDisplays", [1, 1, 1, 1, 1, 1]);
        store.commit('updateCheckoutMarketplaceStep',3);
      
        return;
      }
      else{
        store.dispatch(UPDATE_STEPPER, ["cartDisplayActive"]);
        store.commit("checkoutActiveComponent", PersonalInfo);
        store.commit("setStepperDisplays", [1, 0, 0, 0, 0, 0]);
        store.commit('updateCheckoutMarketplaceStep',1);
      }
      if (store.getters.orderId == undefined)
      {
        store.commit("setStepperDisplays", [1, 0, 0, 0, 0, 0]);
      }    
    }

    return  {
        getOrCreateOrder,
        loadCartItemsFromCookie,
        InitializeStepper,
    }

}